import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

import { SubjectTypeSuggestionState } from "./subject-type-suggestion.interface";

@Injectable({
  providedIn: "root"
})
export class SubjectTypeSuggestionService {
  private readonly _subjectTypeSuggestionState$ = new BehaviorSubject<SubjectTypeSuggestionState>({
    status: "idle",
    suggestion: null,
    error: null,
    appliedSuggestion: false,
    dismissed: false
  });

  private readonly _solarSystemSuggestionState$ = new BehaviorSubject<SubjectTypeSuggestionState>({
    status: "idle",
    suggestion: null,
    error: null,
    appliedSuggestion: false,
    dismissed: false
  });

  private _isPolling = false;

  get subjectTypeSuggestionState$(): Observable<SubjectTypeSuggestionState> {
    return this._subjectTypeSuggestionState$.asObservable();
  }

  get solarSystemSuggestionState$(): Observable<SubjectTypeSuggestionState> {
    return this._solarSystemSuggestionState$.asObservable();
  }

  get subjectTypeSuggestionState(): SubjectTypeSuggestionState {
    return this._subjectTypeSuggestionState$.value;
  }

  get solarSystemSuggestionState(): SubjectTypeSuggestionState {
    return this._solarSystemSuggestionState$.value;
  }

  get isPolling(): boolean {
    return this._isPolling;
  }

  setPollingStatus(isPolling: boolean): void {
    this._isPolling = isPolling;
  }

  updateSubjectTypeSuggestionState(state: SubjectTypeSuggestionState): void {
    this._subjectTypeSuggestionState$.next(state);
  }

  updateSolarSystemSuggestionState(state: SubjectTypeSuggestionState): void {
    this._solarSystemSuggestionState$.next(state);
  }

  reset(): void {
    this._subjectTypeSuggestionState$.next({
      status: "idle",
      suggestion: null,
      error: null,
      appliedSuggestion: false,
      dismissed: false
    });

    this._solarSystemSuggestionState$.next({
      status: "idle",
      suggestion: null,
      error: null,
      appliedSuggestion: false,
      dismissed: false
    });
  }
}
